var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      staticClass: "form-control form-control--select",
      class: _vm.className,
      attrs: { id: _vm.id, name: _vm.name, tabindex: _vm.tabindex },
      on: { change: _vm.onChangeItem },
    },
    [
      _vm.hasPlaceholder
        ? [
            _c("option", { attrs: { value: "" } }, [
              _vm._v(_vm._s(_vm.placeholder)),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "option",
          {
            key: index,
            domProps: { value: item.id, selected: _vm.isSelectedItem(item.id) },
          },
          [_vm._v(_vm._s(item.id))]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }